type Props = {
  min: number;
  max: number;
  minLabel: string;
  maxLabel: string;
  value: number | null;
  onPick: (n: number) => void;
  disabled?: boolean;
};

export function ChipScale({ min, max, minLabel, maxLabel, value, onPick, disabled }: Props) {
  const options: number[] = [];
  for (let n = min; n <= max; n++) options.push(n);
  return (
    <div className="mt-2">
      {/* Apple HIG のタップ領域 44x44pt を高さ (min-h) と幅 (min-w) の両方で確保する。
          **flex-1 だけでは幅が足りない**: チップは max-w-[85%] の AI バブルの中にあるので、
          320px 端末の行幅は実測 225.6px しかなく、5 段階でも (225.6 - 32) / 5 = 38.7px、
          7 段階なら 375px 端末でも 32px まで潰れる。min-w-[44px] は flex の line breaking で
          hypothetical main size に効くため、44px を割るくらいなら flex-wrap で折り返す。
          gap は 6px だと隣接する当たり判定が近すぎるので 8px に広げる。 */}
      <div className="flex flex-wrap gap-2">
        {options.map((n) => {
          const selected = value === n;
          return (
            <button
              key={n}
              type="button"
              aria-pressed={selected}
              disabled={disabled}
              onClick={() => onPick(n)}
              className={
                "flex-1 min-w-[44px] min-h-[44px] py-1 rounded border text-xs font-semibold transition " +
                (selected
                  ? "bg-indigo-600 text-white border-indigo-600"
                  : "bg-white text-slate-700 border-slate-300 hover:border-indigo-400") +
                (disabled ? " opacity-50 cursor-not-allowed" : "")
              }
            >
              {n}
            </button>
          );
        })}
      </div>
      {/* 9px は最小フォント (11pt) 未満。周囲の目盛・注記と揃う 11px に上げる */}
      <div className="flex justify-between text-[11px] text-slate-500 mt-1 px-1">
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
}
